import { useTranslation } from 'react-i18next'

import { GETWorkorderActivitiesRow, Month, TyreProfileMeasurementSystem } from '@cbgms/api'
import { useEnumAsOptions } from '@cbgms/base/enums/use-enum-as-options'
import { Checkbox, Dropdown, TextField } from '@carsys/form'
import { Grid, InputAdornment, Typography } from '@mui/material'
import { IDropdownOption } from '@carsys/ui'
import { TyreChangeCRMDateAlert } from './TyreChangeCRMDateAlert'
import { formatEnum } from '@cbgms/base/utils/helpers'
import React from 'react'

interface Props {
  activityOptions: GETWorkorderActivitiesRow[]
}

export const ChangeTyreFields: React.FC<Props> = ({ activityOptions }) => {
  const { t } = useTranslation()
  const options = useEnumAsOptions(Month, 'EnumMonth')

  const dropdownOptions = React.useMemo<IDropdownOption[]>(() => {
    return activityOptions.map(({ Activity }) => ({
      key: Activity.UUID,
      text: Activity.Description,
      value: Activity.UUID
    }))
  }, [activityOptions])

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Typography component='h2' variant='h6'>
          {t('TyreChange.WarningsTitle')}
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Checkbox label={t('TyreChange.UseSummerThreshold')} name='UseSummerThreshold' />
      </Grid>
      <Grid item xs={6}>
        <Checkbox label={t('TyreChange.UseWinterThreshold')} name='UseWinterThreshold' />
      </Grid>
      <Grid item xs={6}>
        <TextField
          InputProps={{
            inputProps: {
              min: 0.1,
              max: 20
            },
            endAdornment: (
              <InputAdornment position='end'>
                {formatEnum('EnumTyreProfileMeasurementSystem', TyreProfileMeasurementSystem.Millimeters)}
              </InputAdornment>
            )
          }}
          type='number'
          name='SummerMinThreshold'
          label={t('TyreChange.SummerMinThreshold')}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          InputProps={{
            inputProps: {
              min: 0.1,
              max: 20
            },
            endAdornment: (
              <InputAdornment position='end'>
                {formatEnum('EnumTyreProfileMeasurementSystem', TyreProfileMeasurementSystem.Millimeters)}
              </InputAdornment>
            )
          }}
          type='number'
          name='WinterMinThreshold'
          label={t('TyreChange.WinterMinThreshold')}
        />
      </Grid>
      <Grid item xs={6}>
        <Checkbox label={t('TyreChange.UseSummerChangeWarning')} name='UseSummerChangeWarning' />
      </Grid>
      <Grid item xs={6}>
        <Checkbox label={t('TyreChange.UseWinterChangeWarning')} name='UseWinterChangeWarning' />
      </Grid>
      <Grid item xs={6}>
        <Dropdown label={t('TyreChange.SummerChangeWarningMonths')} name='SummerChangeWarningMonths' multiple options={options} />
      </Grid>
      <Grid item xs={6}>
        <Dropdown label={t('TyreChange.WinterChangeWarningMonths')} name='WinterChangeWarningMonths' multiple options={options} />
      </Grid>
      <Grid item xs={12}>
        <TyreChangeCRMDateAlert />
      </Grid>
      <Grid item xs={12}>
        <Typography component='h2' variant='h6' sx={{ mb: 1 }}>
          {t('TyreChange.ActivitiesTitle')}
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Dropdown label={t('TyreChange.ChangeTyresActivityUUID')} name='ChangeTyresActivityUUID' options={dropdownOptions} />
      </Grid>
    </Grid>
  )
}
